import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IDatasource, Query } from 'utility-ts-orm';
import { OpenableElement } from '../../src/builders/openable_element_builder';

export class OpenableElementsQuery implements IQuery {
  private _result: {
    selfAlertDialog: boolean;
    appSupportDrawer: boolean;
    studentFeedbackDialog: boolean;
  };

  constructor(private ngOpenableElementsDatastore: IDatasource<OpenableElement>) {
    Query.registerQuery(this, ngOpenableElementsDatastore);
  }

  run(): OpenableElementsQuery {
    this._result = {
      selfAlertDialog: false,
      appSupportDrawer: false,
      studentFeedbackDialog: false
    };
    const openableElements = this.ngOpenableElementsDatastore.read();
    if (!_4.isEmpty(openableElements)) {
      for (const [key, value] of Object.entries(openableElements)) {
        this._result[key] = value.isOpen;
      }
    }
    return this;
  }

  get result() {
    return this._result;
  }
}

angular.module('capability-ng-priority-feed').service('ngOpenableElementsQuery', OpenableElementsQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-priority-feed/src/queries/openable_elements_query.ts